// The one place the app reads its build-time environment.
//
// Vite inlines each literal `import.meta.env.X` member expression at build time, which is why the
// names have to be spelled out here and cannot be assembled dynamically. The variables keep their
// `REACT_APP_` prefix - `envPrefix` in vite.config.mts tells Vite to expose that prefix instead of
// its default `VITE_`, so .env, the ARG/ENV pairs in the Dockerfile and the pipeline variables all
// stayed exactly as they were through the migration off Create React App.
//
// This file is the entire reason that migration was a one-line-per-variable change: under CRA these
// were `process.env.REACT_APP_*`, read directly in ~55 modules. `process` does not exist in the
// browser under Vite, so every one of those would have had to change, and would have failed at
// runtime rather than at build time - the bundle compiles either way.
//
// The values come from zeiton-react/.env locally and from the ARG/ENV pairs in
// zeiton-react/Dockerfile on the build agent. Adding a variable means touching all three, plus the
// pipeline variables that feed the Docker build args.
//
// These stay `string | undefined` on purpose. A missing variable inlines as `undefined` and surfaces
// as an "undefined/api/..." request rather than a blank app, and that is the behaviour every caller
// was written against - including the unit tests, which run without a .env at all. Modules that
// genuinely cannot start without their URL assert it themselves at import time (see
// services/SignalRService and services/TimeTrackingHub).

export const API_BASE_URL = import.meta.env.REACT_APP_API_BASE_URL;

export const API_HUB_BASE_URL = import.meta.env.REACT_APP_API_HUB_BASE_URL;

export const API_TT_HUB_BASE_URL = import.meta.env.REACT_APP_API_TT_HUB_BASE_URL;

// Declared in .env and the Dockerfile but not read by app code today: MSAL derives its redirect URI
// from window.location.origin instead (see constants/authConfig.ts). Kept here so this module
// remains the complete picture of the environment contract.
export const FRONT_BASE_URL = import.meta.env.REACT_APP_FRONT_BASE_URL;

// Umami statistics for the public download page (features/PublicDownload/analytics.ts). Left empty
// in .env, so local runs are not counted; the production pipeline sets both.
export const UMAMI_SCRIPT_URL = import.meta.env.REACT_APP_UMAMI_SCRIPT_URL;

export const UMAMI_WEBSITE_ID = import.meta.env.REACT_APP_UMAMI_WEBSITE_ID;
